import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=7f105240"
import script from "./copy.vue?vue&type=script&lang=js"
export * from "./copy.vue?vue&type=script&lang=js"
import style0 from "./copy.vue?vue&type=style&index=0&id=7f105240&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports